export const USER_ROLES = ['learner', 'guide'];
export function isUserRole(value) {
    return typeof value === 'string' && USER_ROLES.includes(value);
}
